exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-row{display:-webkit-box;display:-ms-flexbox;display:flex;flex-wrap:wrap}.my-row div>[class*=col-]{display:flex;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f9e256a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/pages/list/Promoted.vue
// module id = 68
// module chunks = 0 1 2